import http from "../base";
import {
  USER_INFO_BY_ID,
  USER_INFO_BY_USERNAME,
  INS_USER_SEARCH,
  ACCOUNT_SET_PUBLIC,
  SET_COMMENT_CONTROL
} from "../constants/path";
import {
  INS_API_FETCH_USER_INFO,
  INS_API_FETCH_USER_INFO_WITH_USERNAME,
  INS_API_USERS_SEARCH,
  INS_API_SET_ACCOUNT_PUBLIC,
  INS_API_SET_COMMENT_CONTROL
} from "../constants/event_consts";
import PresisiteAPIParams from "../persisits/lunch_params";
import { getDeviceInfo } from "@/utils/js_bridge_info";
import { store } from "@/main";
import { GETTER_API_LOGIN_USER_ID } from "@/store/constants/ins_user_info_types";
import { cg_api_signed_body } from "../utils";

/**
 * 通过user_id获取userinfo
 * @param userId
 */
export const userInfoById = async (userId: string): Promise<void> => {
  const query: Record<string, string> = {};
  const loginUserId = store.getters[GETTER_API_LOGIN_USER_ID](userId);
  query.entry_point = userId === loginUserId ? "self_profile" : "profile";
  query.device_id = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  const navChain =
    "IGMainAppViewController:explore_popular:1,IGExploreViewController:explore_popular:3,IGSearchResultsTabViewController:search_users:5";
  try {
    return await http.get(
      USER_INFO_BY_ID(userId),
      {
        headers: {
          "X-IG-Nav-Chain": navChain
        },
        params: query
      },
      { user_id: loginUserId },
      INS_API_FETCH_USER_INFO
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const userInfoWithUsername = async (username: string): Promise<void> => {
  const query: Record<string, string> = {};
  query.device_id = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  const user_id = store.getters[GETTER_API_LOGIN_USER_ID]("");
  try {
    const result = await http.get(
      USER_INFO_BY_USERNAME(username),
      {},
      { user_id },
      INS_API_FETCH_USER_INFO_WITH_USERNAME
    );
    console.log("userInfoWithUsername result", result);
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const usersSearch = (search: string) => {
  const query: Record<string, string> = {};

  query.query = search;
  query.search_surface = "user_search_page";
  query.is_typeahead = "true";
  query.timezone_offset = String(getDeviceInfo().timezone);
  try {
    const navChain =
      "IGMainAppViewController:explore_popular:1,IGExploreViewController:explore_popular:3,IGSearchResultsTabViewController:search_users:5";

    http.get(
      INS_USER_SEARCH,
      {
        params: query,
        headers: {
          "X-IG-Nav-Chain": navChain
        }
      },
      {},
      INS_API_USERS_SEARCH
    );
  } catch (error) {
    //
  }
};

export const setAccountPublic = async (user_id: string) => {
  const body: Record<string, string> = {};
  body._uuid = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  try {
    const navChain =
      "IGProfileViewController:self_profile:2:main_profile,IGSettingsCategoriesViewController:settings_category_options:4:,IGSettingsPrivacyViewController:settings_privacy_options:5:,IGAccountDetailedPrivacySwitchPrivacyViewController:switch_privacy:6:";
    return await http.post(
      ACCOUNT_SET_PUBLIC,
      {
        headers: {
          "X-IG-Nav-Chain": navChain
        },
        data: cg_api_signed_body(body)
      },
      { user_id },
      INS_API_SET_ACCOUNT_PUBLIC
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const setCommentAudienceControlTypeToAny = async (userId: string) => {
  const body: Record<string, string> = {};

  body.audience_control = "any";
  body._uid = userId;
  body._uuid = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  const navChain =
    "IGProfileViewController:self_profile:2:main_profile,IGSettingsCategoriesViewController:settings_category_options:4:,IGSettingsPrivacyViewController:settings_privacy_options:5:,IGReactRootViewController:react_root:6:,IGReactRootViewController:react_root:7:";

  try {
    await http.post(
      SET_COMMENT_CONTROL,
      {
        data: body,
        headers: {
          "X-IG-Nav-Chain": navChain
        }
      },
      { user_id: userId },
      INS_API_SET_COMMENT_CONTROL
    );
  } catch (error) {
    //
  }
};
